/** Copy of the Review order/invoice page (Operations), ported from VentaHub. */
export const opsReview = {
  title: 'Review order/invoice',
  description:
    'Choose a warehouse and a kind of document, open one waiting for review, then approve or reject it.',
  types: {
    VO: 'Vendor order',
    VI: 'Vendor invoice',
    INVOICE: 'Sales invoice',
    CDN: 'Credit/debit note',
  },
  filters: {
    warehouse: 'Warehouse',
    type: 'Document type',
  },
  chooseWarehouse: 'Choose a warehouse',
  chooseWarehouseHint: 'Documents waiting for review are listed per warehouse.',
  empty: 'Nothing waiting for review',
  emptyHint: 'Every document of this kind in this warehouse has been approved.',
  columns: {
    code: 'Document',
  },
  open: 'Open {{code}}',
  detail: {
    loading: 'Loading document',
    download: 'Download',
    state: {
      pending: 'Waiting for review',
      approved: 'Approved',
    },
    approvedOn: 'Approved on {{date}}',
    counterparty: 'Counterparty',
    warehouse: 'Warehouse',
    date: 'Document date',
    currency: 'Currency',
    units: 'Units',
    value: 'Total incl. tax',
    valueWoTax: 'Total excl. tax',
    po: 'PO reference',
    validTill: 'Valid till',
    creditPeriod: 'Credit period',
    creditDays_one: '{{count}} day',
    creditDays_other: '{{count}} days',
    cbm: 'Volume (m³)',
    shippingCost: 'Shipping cost',
    customsDuty: 'Customs duty',
    otherCost: 'Other cost',
    createdBy: 'Created by',
    createdOn: 'Created on',
    updatedOn: 'Last updated',
    ownerEmail: 'Owner email',
    note: 'Document note',
    lines: 'Lines',
    noLines: 'This document has no lines.',
    costIssues_one: '{{count}} line has a cost issue.',
    costIssues_other: '{{count}} lines have a cost issue.',
  },
  lines: {
    sku: 'SKU',
    name: 'SKU name',
    category: 'Category',
    subcategory: 'Sub category',
    box: 'Box',
    quantity: 'Qty',
    cost: 'Cost',
    price: 'Price',
    vat: 'VAT',
    vatPercent: '{{value}}%',
    value: 'Value',
    warehouseStock: 'WH stock',
    orderedCost: 'Ordered cost',
    expiry: 'Expiry',
    nearExpiry: 'Near expiry',
    retailerNlc: 'Retailer NLC',
    buyCost: 'Buy cost',
    retailerSku: 'Retailer SKU',
    vendorInvoice: 'Vendor invoice',
    cndnNumber: 'CN/DN',
    cndnAmount: 'CN/DN amount',
    costIssue: 'Cost issue',
    costIssueFlag: 'Cost issue',
  },
  decision: {
    title: 'Decision',
    choice: 'Decision',
    approve: 'Approve',
    reject: 'Reject',
    comment: 'Comment',
    commentHint: 'Optional. Sent to the person who raised it.',
    reason: 'Reason',
    reasonHint: 'Sent back with the document.',
    reasonRequired: 'Say why it is rejected.',
    escalate: 'Send back to (email)',
    escalateHint: 'Optional. Instead of the person who raised it.',
    badEmail: 'Type one email address.',
    tooLong: 'Keep it under 2,000 characters.',
    note: 'Approving names you as its reviewer. Rejecting changes nothing on the document.',
    submitApprove: 'Approve {{code}}',
    submitReject: 'Reject {{code}}',
    rejecting: 'Rejecting…',
    approving: 'Approving…',
    confirmTitle: 'Approve {{code}}?',
    confirmDescription:
      'You are named as its reviewer and it leaves the review list. This cannot be undone from this page.',
    confirm: 'Yes, approve',
    approved: '{{code}} approved.',
    rejected: '{{code}} rejected.',
    notified: 'Mailed to {{who}}.',
    landedCost_one: 'Landed cost updated for {{count}} SKU.',
    landedCost_other: 'Landed cost updated for {{count}} SKUs.',
  },
  request: {
    open: 'Request review',
    title: 'Request a review of {{code}}',
    description: 'Mails the reviewers the lines as a spreadsheet. Nothing on the document changes.',
    recipients: 'Recipients',
    recipientsHint:
      'Optional. Email addresses, one per line or separated by commas. Leave empty to mail the warehouse’s reviewers.',
    badRecipients: 'One of these is not an email address.',
    tooMany: 'At most 50 recipients.',
    send: 'Send request',
    sending: 'Sending…',
    sent_one: 'Review of {{code}} requested from {{count}} recipient.',
    sent_other: 'Review of {{code}} requested from {{count}} recipients.',
  },
} as const
